export default __webpack_public_path__ + "static/media/big-swap.b365d911.svg";